import { IUISupplier } from '@bridebook/toolbox/src/types';
import { mapSupplierToAnalyticsRecord } from '@bridebook/web/lib/search/utils/map-suppliers/map-supplier-to-analytics-record';
import { PhotographerAnalyticsShape } from '@bridebook/web/lib/search/utils/map-suppliers/shapes';

const mapPhotographersToAnalytics = (list: IUISupplier[]) =>
  list.map(mapSupplierToAnalyticsRecord(PhotographerAnalyticsShape));

export default mapPhotographersToAnalytics;
